<div class="header">
    <button type="button" class="header-search-trigger" (click)="showModal()" (mousedown)="stopFocus($event)"
        aria-label="Search members, rewards, campaigns">
        <lucide-icon name="search" size="16" class="header-search-trigger__icon"></lucide-icon>
        <span class="header-search-trigger__label">Search members, rewards, campaigns...</span>
        <span class="header-search-trigger__kbd">
            @if (isMac) {
            <kbd>⌘</kbd>
            } @else {
            <kbd>Ctrl</kbd>
            }
            <kbd>K</kbd>
        </span>
    </button>

    <!-- Mobile-only icon search button -->
    <button type="button" class="header-search-trigger-mobile" (click)="showModal()" (mousedown)="stopFocus($event)"
        aria-label="Search">
        <lucide-icon name="search" size="18" class="header-search-trigger__icon"></lucide-icon>
    </button>

    <div class="header-icons">
        <div class="header-testProject">
            <button type="button" class="outlet-switcher" nz-dropdown [nzTrigger]="'click'"
                [nzDropdownMenu]="projectMenu" nzOverlayClassName="header-outlet-dropdown-overlay"
                (nzVisibleChange)="onOutletDropdownVisible($event)">
                <span class="or-live-dot" aria-hidden="true"></span>
                <span class="outlet-switcher__label">
                    {{ selectOutlet.outletName || 'Select outlet' }}
                </span>
                <lucide-icon name="chevron-down" size="14" class="outlet-switcher__chevron"></lucide-icon>
            </button>
            <nz-dropdown-menu #projectMenu="nzDropdownMenu">
                <div class="outlet-dropdown-panel" (click)="$event.stopPropagation()">
                    <div class="outlet-dropdown-header"
                        [class.outlet-dropdown-header--search]="outletSearchExpanded">
                        @if (!outletSearchExpanded) {
                        <div class="outlet-dropdown-header__info">
                            <span class="outlet-dropdown-title">Switch outlet</span>
                            <span class="outlet-dropdown-count">{{ outletTotalCount }} total</span>
                        </div>
                        <button type="button" class="outlet-dropdown-search-toggle"
                            (click)="openOutletSearch($event)" aria-label="Search projects">
                            <lucide-icon name="search" size="14"></lucide-icon>
                        </button>
                        } @else {
                        <div class="outlet-dropdown-header__search">
                            <nz-input-group [nzPrefix]="outletSearchPrefix" [nzSuffix]="outletSearchSuffix">
                                <ng-template #outletSearchPrefix>
                                    <lucide-icon name="search" size="14"></lucide-icon>
                                </ng-template>
                                <ng-template #outletSearchSuffix>
                                    @if (outletSearch.trim()) {
                                    <button type="button" class="outlet-dropdown-search-clear"
                                        (click)="clearOutletSearch($event)" aria-label="Clear search">
                                        <lucide-icon name="x" size="14"></lucide-icon>
                                    </button>
                                    }
                                </ng-template>
                                <input #outletSearchInput autocomplete="off" type="search" nz-input
                                    placeholder="Search projects..." [(ngModel)]="outletSearch"
                                    (ngModelChange)="onOutletSearchChange()" />
                            </nz-input-group>
                            <button type="button" class="outlet-dropdown-search-close"
                                (click)="closeOutletSearch($event)" aria-label="Close search">
                                <lucide-icon name="x" size="14"></lucide-icon>
                            </button>
                        </div>
                        }
                    </div>
                    <ul class="outlet-dropdown-list" (scroll)="onOutletListScroll($event)">
                        @if (outletsLoading) {
                        <li class="outlet-dropdown-loading">
                            <nz-spin nzSimple nzSize="small"></nz-spin>
                        </li>
                        } @else {
                        @if (currentOutlet) {
                        <li class="outlet-dropdown-section-label">Current project</li>
                        <li class="outlet-dropdown-item outlet-dropdown-item--active"
                            (click)="applyOutlet(currentOutlet)">
                            <span class="outlet-dropdown-item__icon">
                                <lucide-icon name="map-pin" size="14"></lucide-icon>
                            </span>
                            <span class="outlet-dropdown-item__name">{{ currentOutlet.outletName }}</span>
                            <span class="outlet-status-badge"
                                [class.outlet-status-badge--inactive]="!currentOutlet.isActive">
                                <span class="status-dot"></span>
                                {{ currentOutlet.isActive ? 'Active' : 'Inactive' }}
                            </span>
                            <lucide-icon name="check" size="14" class="outlet-dropdown-item__check"></lucide-icon>
                        </li>
                        }
                        @if (otherFilteredOutlets.length) {
                        <li class="outlet-dropdown-section-label"
                            [class.outlet-dropdown-section-label--spaced]="currentOutlet">Other projects</li>
                        @for (item of otherFilteredOutlets; track item._id) {
                        <li class="outlet-dropdown-item" (click)="applyOutlet(item)">
                            <span class="outlet-dropdown-item__icon">
                                <lucide-icon name="map-pin" size="14"></lucide-icon>
                            </span>
                            <span class="outlet-dropdown-item__name">{{ item.outletName }}</span>
                            <span class="outlet-status-badge"
                                [class.outlet-status-badge--inactive]="!item.isActive">
                                <span class="status-dot"></span>
                                {{ item.isActive ? 'Active' : 'Inactive' }}
                            </span>
                        </li>
                        }
                        }
                        @if (!currentOutlet && !otherFilteredOutlets.length) {
                        <li class="outlet-dropdown-empty">
                            @if (outletSearch.trim()) {
                            No projects match your search
                            } @else {
                            No projects available
                            }
                        </li>
                        }
                        @if (outletLoadingMore) {
                        <li class="outlet-dropdown-load-more">
                            <nz-spin nzSimple nzSize="small"></nz-spin>
                        </li>
                        }
                        }
                    </ul>
                    <div class="outlet-dropdown-footer">
                        <button type="button" class="outlet-dropdown-add" (click)="goToCreateOutlet($event)">
                            <lucide-icon name="plus" size="14"></lucide-icon>
                            <span>Add project</span>
                        </button>
                        <button type="button" class="outlet-dropdown-viewall" (click)="goToViewAllOutlets($event)">
                            <lucide-icon name="store" size="14"></lucide-icon>
                            <span>View all</span>
                        </button>
                    </div>
                </div>
            </nz-dropdown-menu>
        </div>

        @if (planLoaded) {
        <a routerLink="/billing" class="header-plan-chip" [class.header-plan-chip--trial]="planIsTrial"
            [attr.aria-label]="planIsTrial && planDaysLeft !== null
              ? planLabel + ', ' + planDaysLeft + ' days left. ' + planCta
              : planLabel + '. ' + planCta">
            <span class="header-plan-chip__meta">{{ planLabel }}</span>
            @if (planDaysLeft !== null) {
            <span class="header-plan-chip__days">{{ planDaysLeft }}d left</span>
            <span class="header-plan-chip__bar" aria-hidden="true">
                <span [style.width.%]="planProgress"></span>
            </span>
            }
            <span class="header-plan-chip__cta">{{ planCta }}</span>
        </a>
        }

        <div class="header-icon3">
            <button type="button" class="header-icon3-btn" (click)="toggleTheme()"
                [attr.aria-label]="themeMode === 'dark' ? 'Use light mode' : 'Use dark mode'">
                <lucide-icon [name]="themeMode === 'dark' ? 'sun' : 'moon'" size="17"
                    class="header-icon3-lucide"></lucide-icon>
            </button>
            <button type="button" class="header-icon3-btn" (click)="open()" aria-label="Settings">
                <lucide-icon name="settings" size="17" class="header-icon3-lucide"></lucide-icon>
            </button>
        </div>
        <div class="header-profile">
            <button type="button" class="profile-switcher" nz-dropdown [nzDropdownMenu]="profileMenu"
                [nzTrigger]="'click'" nzOverlayClassName="header-profile-dropdown-overlay">
                <span class="profile-switcher__avatar-wrap">
                    {{ userInitials }}
                </span>
            </button>
            <nz-dropdown-menu #profileMenu="nzDropdownMenu">
                <div class="profile-dropdown-panel" (click)="$event.stopPropagation()">
                    <div class="profile-dropdown-header">
                        <span class="profile-dropdown-header__avatar">
                            <lucide-icon name="user-circle" size="20" class="profile-dropdown-header__avatar-icon"></lucide-icon>
                        </span>
                        <div class="profile-dropdown-header__info">
                            <span class="profile-dropdown-header__name">{{ userDisplayName }}</span>
                            @if (userName?.email) {
                            <span class="profile-dropdown-header__email">{{ userName.email }}</span>
                            }
                        </div>
                    </div>
                    <ul class="profile-dropdown-list">
                        <li class="profile-dropdown-item" (click)="openProfile()">
                            <span class="profile-dropdown-item__icon">
                                <lucide-icon name="user" size="15" class="profile-dropdown-item__lucide"></lucide-icon>
                            </span>
                            <span class="profile-dropdown-item__label">My profile</span>
                        </li>
                        <li class="profile-dropdown-item profile-dropdown-item--logout" (click)="logOut()">
                            <span class="profile-dropdown-item__icon">
                                <lucide-icon name="log-out" size="15" class="profile-dropdown-item__lucide"></lucide-icon>
                            </span>
                            <span class="profile-dropdown-item__label">Logout</span>
                        </li>
                    </ul>
                </div>
            </nz-dropdown-menu>
        </div>
    </div>
</div>


<nz-modal [(nzVisible)]="isVisible" [nzClosable]="false" (nzOnCancel)="handleCancel()" [nzFooter]="null"
    [nzBodyStyle]="{ padding: '0' }" nzCentered [nzWidth]="modalWidth"
    [nzWrapClassName]="isMobileView ? 'header-search-modal-wrap header-search-modal-wrap--mobile' : 'header-search-modal-wrap'">
    <ng-container *nzModalContent>
        <div class="search-modal-header">
            <div class="search-modal-header__top">
                <div class="search-modal-header__title">
                    <lucide-icon name="search" size="18" class="search-modal-header__title-icon"></lucide-icon>
                    <span>Quick navigation</span>
                </div>
                <div class="search-type-tabs">
                    <button type="button" class="search-type-tab" [class.active]="searchType === 'pages'" (click)="changeSearchType('pages')">
                        <lucide-icon name="layout" size="14"></lucide-icon>
                        <span>Pages</span>
                    </button>
                    <button type="button" class="search-type-tab" [class.active]="searchType === 'members'" (click)="changeSearchType('members')">
                        <lucide-icon name="users" size="14"></lucide-icon>
                        <span>Members</span>
                    </button>
                </div>
            </div>
            <div class="search-input-container">
                <nz-input-group [nzPrefix]="headerSearchModalTpl" class="header-modal-search-input">
                    <input autocomplete="off" #searchInput type="search" nz-input 
                        [placeholder]="searchType === 'pages' ? 'Search pages...' : 'Search phone number...'"
                        [(ngModel)]="searchText" (ngModelChange)="onSearchTextChange()"
                        (keydown)="onSearchInputKeydown($event)" />
                </nz-input-group>
                <ng-template #headerSearchModalTpl>
                    <lucide-icon name="search" size="16" class="search-input-prefix-icon"></lucide-icon>
                </ng-template>
            </div>
        </div>
        <div class="search-modal-content">
            @if (searchText.trim().length === 0) {
                @if (searchType === 'pages') {
                    <p class="search-section-label">All pages</p>
                } @else {
                    <p class="search-section-label">Search members</p>
                }
            }
            <div class="search-results-container" #searchResultsContainer
                [class.keyboard-nav]="isKeyboardSearchNav"
                (mousemove)="onSearchResultsPointerInteraction()">
                @if (searchType === 'pages') {
                    @for (item of filteredSideMenu; track item.path; let i = $index) {
                    <a class="search-result-item" [class.active]="isSearchResultActive(i)" [routerLink]="item.path" (click)="modalclose()">
                        <span class="search-item-icon">
                            @if (item.icon) {
                            <lucide-icon [name]="item.icon" size="20" class="search-item-lucide-icon"></lucide-icon>
                            }
                        </span>
                        <span class="search-item-content">
                            <span class="search-item-name">{{ item.name }}</span>
                            <span class="search-item-path">{{ item.path }}</span>
                        </span>
                        <lucide-icon name="arrow-right" size="16" class="search-item-arrow"></lucide-icon>
                    </a>
                    }
                } @else {
                    @if (searchText.trim().length === 0) {
                        <div class="search-empty-state">
                            <lucide-icon name="users" size="40" class="search-empty-state__icon"></lucide-icon>
                            <p class="search-empty-state__text">Search for a member</p>
                            <p class="search-empty-state__hint">Enter name or phone number to begin</p>
                        </div>
                    } @else if (membersLoading) {
                        <div class="search-loading-container">
                            <nz-spin nzSimple></nz-spin>
                            <span>Searching members...</span>
                        </div>
                    } @else {
                        @for (member of filteredMembers; track member._id; let i = $index) {
                        <div class="search-result-item" [class.active]="isSearchResultActive(i)" (click)="goToMemberDetail(member)">
                            <span class="search-item-icon">
                                <lucide-icon name="user" size="20" class="search-item-lucide-icon"></lucide-icon>
                            </span>
                            <span class="search-item-content">
                                <span class="search-item-name">{{ member.name || 'Unnamed Member' }}</span>
                                <span class="search-item-path">{{ member.phoneNo || 'No Phone Number' }}</span>
                            </span>
                            <lucide-icon name="arrow-right" size="16" class="search-item-arrow"></lucide-icon>
                        </div>
                        }
                    }
                }

                @if (hasNoResults()) {
                <div class="search-no-results">
                    <lucide-icon name="file-search" size="40" class="search-no-results__icon"></lucide-icon>
                    <p class="search-no-results__text">No results for "{{ searchText }}"</p>
                    <p class="search-no-results__hint">
                        {{ searchType === 'pages' ? 'Try a different page name' : 'Try a different name or phone number' }}
                    </p>
                </div>
                }
            </div>
            <div class="search-modal-footer">
                <span class="search-modal-footer__hint">
                    @if (isMac) {
                    <kbd>⌘</kbd><kbd>K</kbd>
                    } @else {
                    <kbd>Ctrl</kbd><kbd>K</kbd>
                    }
                    to open
                </span>
                <span class="search-modal-footer__hint">
                    <kbd>Esc</kbd> to close
                </span>
            </div>
        </div>
    </ng-container>
</nz-modal>
